import PrivacyPolicy from "@/Component/WithoutLayout/PrivacyPolicy"

const PrivacyPolicyPage = () => {
  return (
    <PrivacyPolicy />
  )
}

export default PrivacyPolicyPage
